import { useContext } from 'react';

import BreadcrumbsContext from './BreadcrumbsContext';

export const useTitle = () => {
  const { title, setTitle } = useContext(BreadcrumbsContext);
  return [title, setTitle];
};
